import React from 'react';
import {
  IconButton,
  Step,
  StepConnector,
  StepLabel,
  Stepper as MUIStepper,
  styled,
  useTheme,
} from '@mui/material';
import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material';
import { StepIconProps, stepConnectorClasses } from '@mui/material';

const QontoConnector = styled(StepConnector)(({}) => ({
  [`& .${stepConnectorClasses.line}`]: {
    display: 'none',
  },
}));

const QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean; theme?: any } }>(
  ({ theme, ownerState }) => ({
    color: ownerState.theme?.palette?.grey[500] || theme.palette.grey[500],
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
      color: ownerState.theme?.palette?.primary.main || theme.palette.primary.main,
    }),
    '& .QontoStepIcon-circle': {
      padding: 0,
      width: 72, // Default width for larger screens
      height: 16,
      borderRadius: '10px',
      backgroundColor: 'currentColor',
    },
  }),
);

function QontoStepIcon(props: StepIconProps & { theme?: any }) {
  const { active, completed, className, theme } = props;
  const muiTheme = useTheme();

  return (
    <QontoStepIconRoot
      ownerState={{ active, theme: theme || muiTheme }}
      className={`${className} px-0`}
    >
      {completed ? (
        <div
          className="QontoStepIcon-circle"
          style={{ backgroundColor: (theme || muiTheme).palette.primary.main }}
        />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

interface StepperProps {
  activeStep: number;
  onBack?: () => void;
  onNext?: () => void;
  theme?: any;
}

const Stepper: React.FC<StepperProps> = ({ activeStep, onBack, onNext, theme }) => {
  const steps = ['1', '2', '3'];

  return (
    <div className="flex justify-center items-center gap-x-4">
      {onBack ? (
        <IconButton color="primary" aria-label="back" onClick={onBack}>
          <ChevronLeftRounded />
        </IconButton>
      ) : (
        <div className="w-[32px]" />
      )}
      <MUIStepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
        {steps.map((label, index) => (
          <Step key={label} completed={activeStep > index}>
            <StepLabel StepIconComponent={(props) => <QontoStepIcon {...props} theme={theme} />} />
          </Step>
        ))}
      </MUIStepper>
      {onNext ? (
        <IconButton color="primary" aria-label="next" onClick={onNext}>
          <ChevronRightRounded />
        </IconButton>
      ) : (
        <div className="w-[32px]" />
      )}
    </div>
  );
};

export default Stepper;
